import { apiClient } from './client.js';

export const aiApi = {
  suggestTags: (entityType, text, existingTags = []) =>
    apiClient.post('/ai/suggest-tags', { entity_type: entityType, text, existing_tags: existingTags }),

  command: (command) =>
    apiClient.post('/ai/command', { command }),
};

export const attentionApi = {
  get: () => apiClient.get('/workspace/attention'),
};
